import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BodySecondary } from '../Base';
import Button from '../Button';
import Modal from '../Modal';
import Spacing from '../Spacing';
const ButtonGroup = styled.div`
  ${p => p.theme.media.md`
    display: flex;
    justify-content: flex-start;
  `};
`;

const FixedWidthButton = styled(Button)`
  margin-bottom: ${p => p.theme.spacing(2)};

  &:last-child {
    margin-bottom: 0;
  }

  ${p => p.theme.media.md`
    width: 150px;
    margin-right: ${p.theme.spacing(2)};
    margin-bottom: 0;
  `};
`;

const ErrorModal = props => {
  const {
    open,
    errorMessage,
    onClose,
    onCtaClick,
    onSecondaryCtaClick
  } = props;

  return (
    <Modal
      open={open}
      title={errorMessage.title}
      serviceNumber={errorMessage.serviceNumber}
      onClose={onClose}
    >
      <Spacing bottom={3} bottomMd={5}>
        <BodySecondary
          dangerouslySetInnerHTML={{ __html: errorMessage.text }}
        />
      </Spacing>
      <ButtonGroup>
        {errorMessage.ctaText && (
          <FixedWidthButton onClick={onCtaClick}>
            {errorMessage.ctaText}
          </FixedWidthButton>
        )}
        {errorMessage.secondaryCtaText && (
          <FixedWidthButton secondary onClick={onSecondaryCtaClick}>
            {errorMessage.secondaryCtaText}
          </FixedWidthButton>
        )}
      </ButtonGroup>
    </Modal>
  );
};

ErrorModal.propTypes = {
  open: PropTypes.bool,
  errorMessage: PropTypes.shape({
    title: PropTypes.string,
    serviceNumber: PropTypes.string,
    text: PropTypes.string,
    ctaText: PropTypes.string,
    secondaryCtaText: PropTypes.string
  }),
  onClose: PropTypes.func,
  onCtaClick: PropTypes.func,
  onSecondaryCtaClick: PropTypes.func
};

export default ErrorModal;
